/**
 * Teams — creating one, nesting it, and putting people on it.
 */

import type { RouteManifestEntry } from '../route-manifest.js';

export const TEAM_ROUTES: readonly RouteManifestEntry[] = [
  {
    id: 'teams',
    path: '/teams',
    entitlement: null,
    entitlementExemption:
      'A team is how a principal reaches every module, not a module a tenant buys — the same ' +
      'reasoning /team carries. Gating it would leave an agency unable to configure the scope ' +
      'that governs what every other screen shows.',
    // Read by everybody, on the same footing as the member list: knowing who is on which team is
    // how anybody makes sense of a scope selector that says "My teams".
    requires: { action: 'read', resource: 'member' },
    authenticated: true,
    nav: { labelKey: 'teams.nav', section: 'administration', order: 1 },
    load: () => import('../screens/people-and-teams.js'),
  },
];
